var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLastRiskEvaluation)?_c('div',[_c('h4',[_vm._v("Evaluación de riesgo")]),_c('risk-answers-view',{attrs:{"snapshot":_vm.riskEvaluationData.snapshot,"answers":_vm.riskEvaluationData.answersRaw}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }